import React from 'react';
import { PiBracketsCurly } from '../react-icons/main/index.esm';
import IconV2 from '../v2/IconV2';
import { useSelector } from 'react-redux';
import argumentSelectors from '@/redux/selectors/argumentSelectors';
import handleEnterRawObject from './argumentRawObjectButton/handleEnterRawObject';

const ArgumentRawObjectButton = ({ actions, argument, dataSource, dataSourcePath, dataSavePath }) => {
  const values = useSelector(argumentSelectors[dataSource].activeArguments());

  const handleEnterRawObjectClick = (e) => handleEnterRawObject(e, argument, values, actions, dataSourcePath, dataSavePath);

  return <IconV2 icon={PiBracketsCurly} className="inactive raw-object-button" title="Use Variables" onClick={handleEnterRawObjectClick} />;
};

export default ArgumentRawObjectButton;
